export default __webpack_public_path__ + "static/media/green-bird.18d2865f.png";